import "./App.css";
import "./index.scss";
import Header from "./components/header/Header";
import Arrow from "./assets/up-arrow/Group 53.svg";
import ProgramOverview from "./components/sections/program overview section/ProgramOverview";
import ScholarshipInfomation from "./components/sections/scholarship information section/ScholarshipInformationSection";
import ApplicationDetails from "./components/sections/application section/ApplicationDetails";
import TeamSection from "./components/sections/team section/TeamSection";
import AcknowledgementsSection from "./components/sections/acknowledgements section/Acknowledgements";
import BSUFooter from "./components/BSUFooter/BSUFooter";
import PeoplePage from "./components/peoplepage/PeoplePage";

function App() {

  const urlParams = new URLSearchParams(window.location.search)


  if(urlParams.get('people')){
    return (
      <PeoplePage />
    )
  }
  return (
    <div className="app">
      <Header />
      <main>
        <ProgramOverview />
        <ScholarshipInfomation />
        <div className="sticky">
          <a href="#top">
            <button>
              Back to the top
              <img src={Arrow} alt="Arrow" />
            </button>
          </a>
        </div>
        <TeamSection />
        <ApplicationDetails />
        <AcknowledgementsSection />
      </main>
      <BSUFooter hideLogo={true}/>
    </div>
  );
}

export default App;
